import { getTempToken } from '@core/js/hooks/auth/pas';
import { SHUFTI, TAG_NAME } from './constants';
import { IGetPlayerTagsRequestData, IGetPlayerTagsResponseData } from '@core/js/hooks/socket/hooks/useGetPlayerTags/types';

export const getVerificationStatus = async (
    getPlayerTags: (request: IGetPlayerTagsRequestData) => Promise<IGetPlayerTagsResponseData>
) => {
    const response = await getPlayerTags({ tagName: TAG_NAME });
    const tagValue = response?.tags?.[0]?.value?.toLowerCase() || '';

    return tagValue;
};

export const requestVerificationUrl = async (userName: string, url = '', auth = '', brandName: string) => {
    const tempToken = await getTempToken();

    const payload = {
        flowName: 'Get Verification url with selfie',
        brandName,
        flowData: {
            imsSessionToken: tempToken?.data?.sessionToken?.sessionToken,
            userName
        }
    };

    const response = await fetch(url, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            Authorization: auth,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    });
    const { actions } = await response.json();
    const verificationAction = actions.find((action: any) => action?.appName?.toLowerCase?.() === SHUFTI);

    return verificationAction?.details?.verificationPageUrl;
};
